import React, { useRef, useImperativeHandle, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  TextField,
  InputAdornment,
  IconButton,
  Avatar,
  Grid,
  Popover,
  Typography,
} from "@material-ui/core";
import LogoAFIP from "../../assets/AFIPlogo.png";
import { startAlerta } from "../../actions/ui/alertas";
import { makeStyles } from "@material-ui/core/styles";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import "moment/locale/es";
import { ValidatorForm/* , TextValidator, SelectValidator */ } from 'react-material-ui-form-validator';

import { useForm } from "../../hooks/useForm";
import { useValidation } from "../../hooks/useValidation";
import { CboLocalidades } from "../cbos/CboLocalidades";
import { CboProvincias } from "../cbos/CboProvincias";
import { CboSeccionales } from "../cbos/CboSeccionales";
import {
  fetchAFIP,
  fetchEmpresaXCUIT,
  empresaTraerPorCUITSuccess,
  empresaTraerAFIPSuccess,
  empresaStartInsert,
} from "../../actions/empresas/empresas";
import { finishSpinner, startSpinner } from "../../actions/ui/spinner";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginLeft: 50,
    marginTop: 50,
  },
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  botonera: {
    marginTop: 25,
  },
  texto: {
    padding: 2,
    margin: 3,
    width: "60vw",
  },
  iconSmall: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
}));

export const ABMEmpresas = React.forwardRef(({ cerrarPop, empresaAfiliado }, ref) => {
  const classes = useStyles();
  moment.locale("es");
  const dispatch = useDispatch();
  const { empresa } = useSelector((state) => state.empresas);
  const [
    formValues,
    handleInputChange,
    reset,
    setearValor,
    setearValor2,
  ] = useForm(empresa);
  const {
    denominacion,
    domicilio,
    codigoPostal,
    telefono,
    email,
    cuit,
    fechaAlta,
    fechaBaja,
    observacion,
    idSeccional,
    idProvincia,
    idLocalidad,
    actividadPrincipal,
    estadoAFIP,
  } = formValues;
  const [datosValidos, setDatosValidos] = useState(true);
  const activeId = useRef(empresa?.cuit);
  const [
    valuesValidation,
    handleInputChangeValidation,
    resetValidation,
    setearValorValidation,
  ] = useValidation(empresa);

  const handleCPChange = (e) => {
    let reg = new RegExp("^[0-9]+$");
    if (e.target.value === "" || reg.test(e.target.value)) {
      setearValor("codigoPostal", e.target.value);
    }
  };

  useEffect(() => {
    setDatosValidos(true);
    for (var key of Object.keys(valuesValidation)) {
      if (valuesValidation[key]) {
        setDatosValidos(false);
      }
    }
  }, [valuesValidation, datosValidos]);

  useEffect(() => {
    if (empresaAfiliado?.empresa.cuit) {
      setearValor("cuit", empresaAfiliado?.empresa.cuit);
    }
  }, [empresaAfiliado?.empresa.cuit, setearValor])

  useImperativeHandle(ref, () => ({
    guardarEmpresa(e) {
      e.preventDefault();
      if (datosValidos && Object.keys(formValues).length > 0 && formValues.constructor === Object) {
        dispatch(empresaStartInsert(formValues));
        cerrarPop();
      }
    },
  }));

  const handleCUITChange = (e) => {
    let reg = new RegExp("^[0-9]+$");
    if (e.target.value === "" || reg.test(e.target.value)) {
      setearValor("cuit", e.target.value);
    }
    if (e.target.value.toString().length === 11) {
      setearValorValidation("cuit", false);
    }
  };
  const { items } = useSelector((state) => state.localidades);
  const handleLocalidadChange = (e) => {
    if (items?.length > 0) {
      const localidad = items.find(
        (loc) => parseInt(loc?.id_localidad) === parseInt(e.target.value)
      );
      setearValor2(
        "idLocalidad",
        localidad?.id_localidad,
        "idProvincia",
        localidad?.id_provincia
      );
    }
  };
  const [habilitarCampos, setHabilitarCampos] = useState(true);
  const [estado, setEstado] = useState("ALTA");
  const [habilitarCUIT, setHabilitarCUIT] = useState(false);
  const handleTelefonoChange = (e) => {
    let reg = new RegExp("^[0-9]+$");
    if (e.target.value === "" || reg.test(e.target.value)) {
      setearValor("telefono", e.target.value);
    }
  };
  const handleCuitAFIP = async () => {
    if (cuit?.toString().length === 11) {
      dispatch(startSpinner());
      setearValorValidation("cuit", false);
      dispatch(fetchEmpresaXCUIT(cuit));
      const empresaRequest = await dispatch(fetchEmpresaXCUIT(cuit));
      if (empresaRequest) {
        //existe en padron
        setEstado("MODIFICAR");
        dispatch(empresaTraerPorCUITSuccess(empresaRequest));
        dispatch(
          startAlerta(`Empresa Existente`, "info", empresa.denominacion)
        );
        setHabilitarCampos(false);
        setHabilitarCUIT(true);
      } else {
        //no existe en padron valido en afip
        const empresaAFIP = await dispatch(fetchAFIP(cuit));

        if (empresaAFIP) {
          setEstado("ALTA");
          dispatch(empresaTraerAFIPSuccess(empresaAFIP));
          setHabilitarCampos(false);
          setHabilitarCUIT(true);
        }
      }
    } else {
      setearValorValidation("cuit", true);
      dispatch(
        startAlerta(
          `El CUIT ingresado debe contener 11 digitos`,
          "error",
          "Verifique CUIT"
        )
      );
      dispatch(finishSpinner());
    }
  };


  useEffect(() => {
    if (empresa && empresa.cuit !== activeId.current) {
      reset(empresa);
      resetValidation(empresa);
      activeId.current = empresa.cuit;
    }
  }, [empresa, reset, resetValidation]);



  const validateEmail = (email) => {
    // let reg = new RegExp(`[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+`);
    let reg = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
    if (reg.test(email) || email?.length === 0) {
      setearValorValidation("email", false);
    } else {
      setearValorValidation("email", true);
    }
  };
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div className={classes.root}>
      <ValidatorForm>
        {/* <h2>ABM de Empresas</h2> */}
        <div>
          <Popover
            id="mouse-over-popover"
            className={classes.popover}
            classes={{
              paper: classes.paper,
            }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus
          >
            <Typography>Ingrese CUIT de la Empresa y busque en AFIP</Typography>
          </Popover>
        </div>

        <Grid container spacing={2}>
          <Grid item xs={2}>
            <TextField
              margin="normal"
              fullWidth={true}
              label="CUIT"
              disabled={habilitarCUIT}
              aria-owns={open ? "mouse-over-popover" : undefined}
              aria-haspopup="true"
              onMouseEnter={(e) => {
                cuit?.length === 0 && handlePopoverOpen(e);
              }}
              onMouseLeave={handlePopoverClose}
              onFocus={handlePopoverClose}
              onClick={handlePopoverClose}
              name="cuit"
              error={valuesValidation["cuit"]}
              helperText={
                valuesValidation["cuit"] && "Obligatorio con 11 caracteres"
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <IconButton onClick={handleCuitAFIP}>
                      <Avatar
                        className={classes.iconSmall}
                        src={LogoAFIP}
                      ></Avatar>
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              value={`${cuit || ""}`}
              autoComplete="off"
              autoFocus
              onChange={(e) => {
                handleCUITChange(e);
              }}
              inputProps={{
                maxLength: 11,
              }}
            />
          </Grid>
          <Grid item xs={5}>
            <TextField
              margin="normal"
              fullWidth={true}
              disabled={habilitarCampos}
              label="Denominacion"
              name="denominacion"
              value={`${denominacion || ""}`}
              autoComplete="off"
              onChange={(e) => {
                handleInputChangeValidation(e);
                handleInputChange(e);
              }}
              error={valuesValidation["denominacion"]}
              helperText={valuesValidation["denominacion"] && "Obligatorio"}
              required={true}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              margin="normal"
              fullWidth={true}
              label="Domicilio"
              name="domicilio"
              disabled={habilitarCampos}
              value={`${domicilio || ""}`}
              autoComplete="off"
              error={valuesValidation["domicilio"]}
              helperText={valuesValidation["domicilio"] && "Obligatorio"}
              required={true}
              onChange={(e) => {
                handleInputChangeValidation(e);
                handleInputChange(e);
              }}
            />
          </Grid>
        </Grid>
        {/* division */}
        <Grid container spacing={1}>
          <Grid item xs={2}>
            <TextField
              margin="normal"
              disabled={habilitarCampos}
              inputProps={{ maxLength: 4 }}
              value={codigoPostal || ""}
              onChange={(e) => {
                handleCPChange(e);
                handleInputChangeValidation(e);
              }}
              label="Cod. Postal"
              name="codigoPostal"
              error={valuesValidation["codigoPostal"]}
              helperText={valuesValidation["codigoPostal"] && "Obligatorio"}
              required={true}
              autoComplete="off"
            />
          </Grid>
          <Grid item xs={2}>
            <CboLocalidades
              manejadorInputChange={(e) => {
                handleLocalidadChange(e);
                handleInputChangeValidation(e);
              }}
              manejadorInputChangeValidation={handleInputChangeValidation}
              valuesValidation={valuesValidation}
              valor={idLocalidad}
              name="idLocalidad"
              deshabilitado={habilitarCampos}
              cp={codigoPostal ? codigoPostal : 0}
            />
          </Grid>
          <Grid item xs={2}>
            <CboProvincias
              manejadorInputChange={handleInputChange}
              valor={idProvincia}
              deshabilitado={true}
              manejadorInputChangeValidation={handleInputChangeValidation}
              valuesValidation={valuesValidation}
            />
          </Grid>

          <Grid item xs={2}>
            <CboSeccionales
              manejadorInputChange={handleInputChange}
              valor={idSeccional}
              name="idSeccional"
              manejadorInputChangeValidation={handleInputChangeValidation}
              valuesValidation={valuesValidation}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              margin="normal"
              value={email || ""}
              disabled={habilitarCampos}
              error={valuesValidation["email"]}
              helperText={valuesValidation["email"] && "Invalido"}
              onChange={(e) => {
                handleInputChange(e);
                handleInputChangeValidation(e);
              }}
              onBlur={() => {
                validateEmail(email);
              }}
              required={true}
              label="EMail"
              name="email"
              autoComplete="off"
              fullWidth
            />
          </Grid>
        </Grid>
        {/* division */}
        <Grid container spacing={1}>
          {" "}
          <Grid item xs={2}>
            <TextField
              fullWidth
              margin="normal"
              disabled={habilitarCampos}
              value={telefono || ""}
              onChange={(e) => {
                handleTelefonoChange(e);
                handleInputChangeValidation(e);
              }}
              label="Telefono"
              error={valuesValidation["telefono"]}
              helperText={valuesValidation["telefono"] && "Obligatorio"}
              required={true}
              name="telefono"
              autoComplete="off"
            />
          </Grid>
          <Grid item xs={2}>
            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
              <KeyboardDatePicker
                margin="normal"
                disabled={habilitarCampos}
                id="dialogfechaAlta"
                label="Fec. Alta."
                format="dd/MM/yyyy"
                okLabel="Aceptar"
                required={true}
                maxDate={new Date()} //maxDate
                clearLabel="Limpiar"
                cancelLabel="Cancelar"
                value={moment(fechaAlta).isValid() ? moment(fechaAlta) : ""}
                onChange={(date) => {
                  setearValor("fechaAlta", date);
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={2}>
            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
              <KeyboardDatePicker
                margin="normal"
                disabled={estado === "ALTA"}
                id="dialogfechaBaja"
                label="Fec. Baja."
                format="dd/MM/yyyy"
                okLabel="Aceptar"
                maxDate={new Date()} //maxDate
                clearLabel="Limpiar"
                cancelLabel="Cancelar"
                value={moment(!!fechaBaja).isValid() ? moment(fechaBaja) : null}
                onChange={(date) => {
                  setearValor("fechaBaja", date);
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={2}>
            <TextField
              fullWidth
              disabled={true}
              margin="normal"
              value={estadoAFIP || ""}
              onChange={(e) => {
                handleTelefonoChange(e);
                handleInputChangeValidation(e);
              }}
              label="Estado en AFIP"
              error={valuesValidation["estadoAFIP"]}
              helperText={valuesValidation["estadoAFIP"] && "Obligatorio"}
              name="estadoAFIP"
              autoComplete="off"
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              disabled={true}
              margin="normal"
              value={actividadPrincipal || ""}
              onChange={(e) => {
                handleTelefonoChange(e);
                handleInputChangeValidation(e);
              }}
              label="Actividad Principal"
              error={valuesValidation["actividadPrincipal"]}
              helperText={valuesValidation["actividadPrincipal"] && "Obligatorio"}
              name="actividadPrincipal"
              autoComplete="off"
            />
          </Grid>
          {/* division */}
          <Grid container spacing={1}></Grid>
          <Grid item xs={4}>
            <TextField
              className={classes.texto}
              placeholder="Ingrese una observacion"
              multiline
              rows={4}
              name="observacion"
              disabled={habilitarCampos}
              onChange={handleInputChange}
              rowsMax={8}
              value={observacion}
              variant="outlined"
            />
          </Grid>
        </Grid>
      </ValidatorForm>
    </div>
  );
});
